import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { OUTCOMES } from "../../../constants";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { SingleTextForm } from "../shared/SingleTextForm";
import { AuthContext } from "../../../AuthContextWrapper";

interface Props {
  screenData?: any;
}

export const BizNameScreen = ({ screenData }: Props): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const { flow } = useContext(AuthContext);
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  const business = screenData?.length && screenData[0];
  const name = (business?.name as string) || "";

  const handleComplete = async (name: string): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    // TODO: replace "me" with businesses identifier needed to save data
    if (
      !(await flow?.saveData(currentScreen, "me", {
        name: name,
      }))
    ) {
      throw new Error("could not save data");
    }

    flow?.navigateToNext(currentScreen, OUTCOMES.complete, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper title="What is the name of your businesses or practice?">
      <SingleTextForm
        initText={name}
        textLabel="Business name"
        onComplete={handleComplete}
        onBack={() => navigate(-1)}
      />
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
